import { Controller } from "@hotwired/stimulus";

// LRPO-5487 — Live-sync the Report Emails timezone label with the event
// Time zone <select> before the form is saved.
//
// The label + "Default UTC…" warning badge in _report_emails_fieldset are
// rendered server-side from @event.time_zone, so they stay stale until the
// event is saved. This mirrors the currently-selected value into the label
// and shows/hides the UTC badge on every change, matching what the server
// would render after a save. The server-rendered initial state is
// authoritative — this only reacts to user edits.
//
// Scope: mounted on the event <form> so the timezone <select> (elsewhere in
// the form) and the label/badge (inside the fieldset) share one controller.
//
// Targets:
//   - select: the event[time_zone] <select>
//   - label:  the <strong> holding the timezone text
//   - badge:  the UTC warning <span> (always in the DOM; hidden unless UTC)
export default class extends Controller {
  static targets = ["select", "label", "badge"];

  update() {
    if (!this.hasSelectTarget || !this.hasLabelTarget) return;

    const value = this.selectTarget.value;
    this.labelTarget.textContent = value === "" ? "NOT SET" : value;

    if (this.hasBadgeTarget) {
      this.badgeTarget.hidden = value !== "UTC";
    }
  }
}
